import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import Response from './pages/Response';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/response" element={<Response />} />
    </Routes>
  );
}

export default App;
